//clue types
export const freeTextQuestion = 'freeTextQuestion';
export const mixAndMatch= 'mixAndMatch';
export const multipleChoice= 'multipleChoice';
export const clueTypes = [freeTextQuestion, mixAndMatch, multipleChoice];
//non-clue types
export const informational = 'informational';
export const answer = 'answer';
export const newLocation = 'newLocation';
export const locationDone = 'locationDone';
//special types
export const tip = 'tip';
export const teamName = 'teamName';
export const rateUs = 'rateUs';
export const payUs = 'payUs';